export default __webpack_public_path__ + "static/278234275_290920573215908_2122508792329180039_n-b13306a85b99acd150d7900cfa73daba.jpeg";